import { onCLS, onFID, onLCP } from 'web-vitals';
import trackingService from './tracking';

const { coreWebVitals } = trackingService;
const coreWebVitalsTrack = coreWebVitals.bind(trackingService);

onCLS(coreWebVitalsTrack);
onFID(coreWebVitalsTrack);
onLCP(coreWebVitalsTrack);